<template>
  <vx-card v-show="isCardActiveLocal" class="mt-3 mb-4" title="Final Summary">
    <div class="vx-row">
      <div class="flex flex-wrap items-center justify-center">
        <p class="ml-4 mr-2">Final Score: </p>
        <vs-input type="number" autocomplete="off" style="width: 58px;" class="mr-2" min="0" size="small" :max="uploadTask.totalMarks" name="score" v-model="uploadTask.achievedMarks" />
        <p class="mr-2">/</p>
        <vs-input type="number" autocomplete="off" style="width: 58px;" class="mr-2" min="0" size="small" name="total" v-model="uploadTask.totalMarks" />
      </div>
    </div>
    <div v-if="uploadTask.assessorComment" class="mt-2 vx-row">
      <div class="vx-col flex-1">
        <label><strong>Assessor Comment:</strong></label>
        <vs-textarea readOnly v-model="uploadTask.assessorComment" />
      </div>
    </div>
    <div class="mt-2 vx-row">
      <div class="vx-col flex-1">
        <label>Your Comment:</label>
        <vs-textarea v-model="uploadTask.studentComment" />
      </div>
    </div>
  </vx-card>
</template>

<script>
  import vSelect from 'vue-select'
  export default {
    components: {
      'v-select': vSelect
    },
    props: {
      isCardActive: {
        type: Boolean,
        required: true
      },
      uploadTask: {
        type: Object,
        required: false
      }
    },
    data() {
      return {
        
      }
    },
    computed: {
      isCardActiveLocal: {
        get() {
          return this.isCardActive;
        },
        set(val) {
          if (!val) {
            
          }
        }
      },
    },
    watch: {
      isCardActive: function(val) {
        if(val){
          var self = this;
          
        }
      }
    },
    mounted() {
      
    },
  }

</script>

<style lang="scss">

</style>
